export default "__VITE_ASSET__CluUwrKA__"